var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMetaData)?_c('dl',[_vm._l((_vm.metaData),function(field,index){return [_c('dt',{key:("dt-" + index)},[_vm._v(_vm._s(((field.key) + ":")))]),_vm._v(" "),_c('dd',{key:("dd-" + index)},[_vm._v(_vm._s(field.value))])]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }